import { getDangerProducts, deleteDangerProducts, createDangerProducts, editDangerProducts } from "./danger-products";
import { useMutation,useQuery } from "react-query";

export const useDangerProducts = (params) => {
  const queryKey = ['getDangerProducts', params]; 
  const { data, refetch, isLoading, error } = useQuery(
    queryKey,
    () => getDangerProducts(params),
    {
      keepPreviousData: true,
    }
  );

  return { data, refetch, isLoading, error };
};

export const useDeleteDangerProducts = () => {
  const mutation = useMutation({
    mutationFn: (params) => deleteDangerProducts(params), 
  });

  return mutation;
};

export const useCreateDangerProducts = () => {
    const mutation = useMutation({
        mutationFn: (params) => createDangerProducts(params),
    });

    return mutation;
};


export const useEditDangerProducts = () => {
    const mutation = useMutation({
        mutationFn: ({ id, name }) => editDangerProducts(id, name),
    });

    return mutation;
};